import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { fmtDay, fmtTime } from "@/lib/dates";

const elapsed = (from) => {
  const ms = Date.now() - new Date(from).getTime();
  const m = Math.max(0, Math.floor(ms / 60000));
  return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, "0")}m`;
};

export const ClockCard = () => {
  const [st, setSt] = useState(null);
  const [startedAt, setStartedAt] = useState(null);
  const [, tick] = useState(0);
  const load = useCallback(() => {
    api.get("/me/clock").then((r) => {
      setSt(r.data);
      if (r.data.active) {
        const offset = new Date(r.data.server_now).getTime() - Date.now();
        setStartedAt(new Date(new Date(r.data.active.clock_in).getTime() - offset));
      }
    });
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(() => tick((x) => x + 1), 30000);
    return () => clearInterval(t);
  }, [load]);

  const act = async (path) => {
    try {
      await api.post(`/me/${path}`);
      toast.success(path === "clock-in" ? "Clocked in" : "Clocked out");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  if (!st) return null;
  const on = !!st.active;
  return (
    <div className={`rounded-2xl p-6 text-white ${on ? "bg-emerald-700" : "bg-slate-950"}`} data-testid="clock-card">
      <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider">
        <span className={`h-2.5 w-2.5 rounded-full ${on ? "pulse-ring bg-emerald-300" : "bg-slate-500"}`} />
        <span data-testid="clock-status">{on ? "Clocked in" : "Clocked out"}</span>
      </div>
      {on ? (
        <p className="mt-3 font-display text-4xl font-bold" data-testid="clock-elapsed">{startedAt ? elapsed(startedAt) : ""}</p>
      ) : (
        <p className="mt-3 font-display text-2xl font-semibold">Ready when you are.</p>
      )}
      {on && <p className="mt-1 text-sm text-emerald-100">Since {fmtDay(st.active.clock_in)} {fmtTime(st.active.clock_in)}</p>}
      <Button onClick={() => act(on ? "clock-out" : "clock-in")} className={`mt-6 h-14 w-full rounded-full text-base font-bold ${on ? "bg-white text-emerald-800 hover:bg-emerald-50" : "bg-indigo-500 hover:bg-indigo-400"}`} data-testid={on ? "clock-out-button" : "clock-in-button"}>
        {on ? "Clock out" : "Clock in"}
      </Button>
    </div>
  );
};
